<script setup lang="ts">
import Popup from "@/components/global/Popup.vue";
import { onMounted, onUnmounted } from "vue";

const emit = defineEmits<{
  (e: 'close'): void
}>();

function close() {
  emit("close");
}

onMounted(() => {
  document.body.style.overflow = "hidden";
})

onUnmounted(() => {
  document.body.style.overflow = "";
})

</script>

<template>
  <popup :value="true">
    <div class="popup_wrap">
      <slot />
      <button class="close" @click="close"></button>
    </div>
  </popup>
</template>

<style lang="less" scoped>
.popup_wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: fadeUpIn 0.3s forwards;
}

.close {
  width: 0.72rem;
  height: 1.27rem;
  cursor: pointer;
  background: url("~/images/pop/close.png") no-repeat left top / cover;
  transition: all 0.1s;

  &:hover {
    transform: scale(1.02);
  }
}

// .wap {
//   .close {
//     top: -0.5rem;
//     right: 0;
//   }
// }</style>
